module.exports = __webpack_public_path__ + "static/media/top_shape_5_mob.b469830a.svg";